module.exports = __webpack_public_path__ + "img/19.7.Chla.8d461b92.png";